import type {MemexProjectColumnId} from '../../api/columns/contracts/memex-column'
import type {MemexItemModel} from '../../models/memex-item-model'
import {useHasColumnData} from '../../state-providers/columns/use-has-column-data'
import {itemHasColumnLoaded} from '../../state-providers/memex-items/memex-items-data'
import {useEnabledFeatures} from '../use-enabled-features'

export const useIsColumnLoadedForItem = (item: MemexItemModel, columnId: MemexProjectColumnId) => {
  const {memex_mwl_field_loading, memex_table_without_limits} = useEnabledFeatures()
  if (memex_mwl_field_loading && memex_table_without_limits) {
    return itemHasColumnLoaded(item, columnId)
  }
  // It's safe to conditionally call this hook here since FF values
  // do not change during the lifetime of the app
  // eslint-disable-next-line react-hooks/rules-of-hooks
  return useIsColumnLoaded(columnId)
}

export const useIsColumnLoaded = (columnId: MemexProjectColumnId) => {
  const isColumnLoaded = useLazyIsColumnLoaded()
  return isColumnLoaded(columnId)
}

function useLazyIsColumnLoaded() {
  const {hasColumnData} = useHasColumnData()
  return (columnId: MemexProjectColumnId) => hasColumnData(columnId)
}
